import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import { changeOnlyProgrammaticDealData } from 'store/dealManagement/reducer';

interface UseDspSync {
  dspSeatId: string;
  isWithDspSync: boolean;
  updateDspSeat: (seatId?: string) => void;
}

export const useDspSync = (): UseDspSync => {
  const dispatch = useDispatch();
  const { dspSeatId, syncWithDsp: isWithDspSync } = useSelector((state: Store) => state.dealManagement.programmatic);

  const updateDspSeat = useCallback(
    (seatId?: string) => {
      dispatch(changeOnlyProgrammaticDealData({ dspSeatId: seatId }));
    },
    [dispatch],
  );

  return {
    dspSeatId,
    isWithDspSync,
    updateDspSeat,
  };
};
